import React, { useState, useEffect } from "react";
import config from "../../Common/Configurations/APIConfig";
import apiService from "../../Common/Configurations/APIService";
import Header from "../../Common/Layout/Header";
import { useAuth } from "../../Common/Configurations/AuthContext";
import { Link } from "react-router-dom";
import moment from "moment";
import DeleteAlert from "../../Common/Layout/DeleteAlert";
import { useNavigate } from "react-router-dom";
import "../Package/Package.css";
import UmrahTabs from "../AllTabs/UmrahTabs";
import ConfirmationModal from "../../Common/Layout/ConfirmationModal";

const WebsiteUmrahList = () => {
  const { user, loading } = useAuth();
  const [lists, setLists] = useState([]);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [itemToDelete, setItemToDelete] = useState(null);
  const [showCopyModal, setShowCopyModal] = useState(false);
  const [itemToCopy, setItemToCopy] = useState(null);
  const [copyingId, setCopyingId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [togglingId, setTogglingId] = useState(null);
  const navigate = useNavigate();

  const GetData = async (pageNum, currentSearchTerm) => {
    setIsLoading(true);
    try {
      let url = `${config.GETWEBSITEPACKAGES}/${user?.cid}?PageNumber=${pageNum}&PageSize=${pageSize}&type=Umrah`;

      if (currentSearchTerm) {
        url += `&search=${encodeURIComponent(currentSearchTerm)}`;
      }

      const res = await apiService.getAll(url);
      setLists(res.data);
      setPageNumber(res.pageNumber);
      setPageSize(res.pageSize);
      setTotalPages(res.totalPages);
      setTotalRecords(res.totalRecords);
    } catch (error) {
      console.error("Error fetching website holiday packages:", error);
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!loading && !user) {
      navigate("/");
    }
  }, [user, loading, navigate]);

  useEffect(() => {
    if (user) {
      GetData(pageNumber, searchTerm);
    }
  }, [user, pageNumber]);

  useEffect(() => {
    setPageNumber(1);
    const debounceTimer = setTimeout(() => {
      if (user) {
        GetData(1, searchTerm);
      }
    }, 350);
    return () => {
      clearTimeout(debounceTimer);
    };
  }, [user, searchTerm]);

  if (loading) {
    return <p>Loading...</p>;
  }
  const handleToggleIsWebsite = async (packageId, currentStatus) => {
      if (togglingId) return;
      setTogglingId(packageId);
  
      const newStatus = !currentStatus;
  
      try {
        const resourceUrl = `${config.UPDATETOGGLE}?id=${packageId}`;
        const requestBody = { isWebsite: newStatus };
        await apiService.update(resourceUrl, requestBody);

        await GetData(pageNumber, searchTerm);
  
      } catch (error) {
        console.error("Failed to toggle website status:", error);
      } finally {
        setTogglingId(null);
      }
    };
  const handleOpenDeleteModal = (id) => {
    setItemToDelete(id);
    setShowDeleteModal(true);
  };

  const handleCloseDeleteModal = () => {
    setShowDeleteModal(false);
    setItemToDelete(null);
  };
   const handleOpenCopyModal = (id) => {
    setItemToCopy(id);
    setShowCopyModal(true);
  };

  const handleCloseCopyModal = () => {
    setShowCopyModal(false);
    setItemToCopy(null);
  };


  const handleDelete = async () => {
    if (itemToDelete !== null) {
      try {
        await apiService.remove(config.DELETEPACKAGE, itemToDelete);
        GetData(pageNumber, searchTerm); 
      } catch (error) {
        console.error("Error deleting package:", error);
      }
      handleCloseDeleteModal();
    }
  };

   const handleClone = async () => {
    if (!itemToCopy) return;
    
    setCopyingId(itemToCopy); // This will show "Copying..." on the button
    handleCloseCopyModal();   // Close the modal immediately for better UX
    
    try {
      await apiService.post(`${config.CLONEPACKAGE}/${itemToCopy}`);
      GetData(pageNumber, searchTerm);
    } catch (error) {
      console.error("Error cloning package:", error);
    } finally {
      setCopyingId(null); // Reset the copying state when done
    }
  };
  const GetLastPageData = () => GetData(totalPages, searchTerm);
  const GetFirstPageData = () => GetData(1, searchTerm);
  const GetPageData = (number) => {
    if (pageNumber !== number) {
      setPageNumber(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className={`page-item ${pageNumber === number ? "active" : ""}`}
        key={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });

  return (
    <div id="layout-wrapper">
      <Header User={user} />
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="card">
              <div className="p-2">
                <UmrahTabs pageName="WEBSITEUMRAHPACKAGES" />
              </div>
              <div className="card-body">
                <div className="row g-3 mb-4">
                  <div className="col-xl-4 col-lg-6">
                    <div className="search-box">
                      <input
                        type="text"
                        className="form-control search"
                        placeholder="Search website packages..." // MODIFIED
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                    </div>
                  </div>
                  <div className="col-xl-2 col-lg-3">
                    <div className="hstack gap-2">
                      <button
                        className="btn btn-danger"
                        onClick={() => {
                          setSearchTerm("");
                          setPageNumber(1);
                        }}
                      >
                        <i className="ri-refresh-line align-bottom me-1"></i> Reset
                      </button>
                    </div>
                  </div>
                </div>

                {isLoading ? (
                  <div className="text-center py-5">
                    <div className="spinner-grow text-primary" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </div>
                    <p className="mt-3 text-muted">Loading packages...</p>
                  </div>
                ) : (
                  <>
                    <div className="row">
                      {lists.map((packageItem) => (
                        <div key={packageItem.packageId} className="col-xl-3 col-md-6">
                          <div className="card package-card">
                            <div className="card-body">
                                                          <div className="package-img-container">
                                                            <img
                                                              src={
                                                                packageItem.imageSrc ||
                                                                "https://via.placeholder.com/300x200?text=Package"
                                                              }
                                                              className="img-fluid rounded"
                                                              alt={packageItem.packageName}
                                                            />
                                                            <div className="package-price-badge">
                                                              {packageItem.currency}
                                                              {packageItem.price}
                                                            </div>
                                                            <div className="package-duration-badge">
                                                              {packageItem.duration}
                                                            </div>
                            
                                                          </div>
                            
                                                          <div className="mt-3">
                                                            <div className="d-flex justify-content-between align-items-center mb-2">
                            
                                                              <h5 className="mb-0">
                                                                {packageItem.packageName}
                                                              </h5>
                                                              <div
                                    className="form-check form-switch status-toggle"
                                    title={packageItem.isWebsite ? "Visible on website" : "Hidden from website"}
                                  >
                                    <input
                                      className="form-check-input"
                                      type="checkbox"
                                      role="switch"
                                      id={`websiteSwitch-${packageItem.packageId}`}
                                      checked={packageItem.isWebsite}
                                      onChange={() => handleToggleIsWebsite(packageItem.packageId, packageItem.isWebsite)}
                                      disabled={togglingId === packageItem.packageId}
                                    />
                                    <label
                                      className="form-check-label"
                                      htmlFor={`websiteSwitch-${packageItem.packageId}`}
                                    >
                                      
                                    </label>
                                  </div>
                                                            </div>
                            
                                                            <p className="text-muted mb-2">
                                                              <i className="ri-map-pin-line align-bottom me-1"></i>
                                                              {packageItem.destinationName}
                                                            </p>
                                                            <div className="d-flex justify-content-between mb-2">
                                                              <span>
                                                                <i className="ri-calendar-line align-bottom me-1"></i>
                                                                {moment(packageItem.startedDate).format(
                                                                  "DD MMM YYYY"
                                                                )}
                                                              </span>
                                                              <span>
                                                                <i className="ri-user-line align-bottom me-1"></i>
                                                                {packageItem.noOfPersons}
                                                              </span>
                                                            </div>
                                                            <div className="d-flex flex-wrap gap-1">
                                                              
                                                                                               <Link
                                                                to={`/umrahpackage/${packageItem.packageId}`} 
                                                                state={{ activeTab: 9 }} 
                                                                className="btn btn-sm btn-warning text-black"
                                                              >
                                                                <i className="ri-eye-line align-bottom me-1"></i>{" "}
                                                                View
                                                              </Link>
                                                              <Link
                                                                to={`/umrahpackage/${packageItem.packageId}`}
                                                                className="btn btn-sm btn-primary"
                                                              >
                                                                <i className="ri-pencil-line align-bottom me-1"></i>{" "}
                                                                Edit
                                                              </Link>
                                                              <button
                                                                className="btn btn-sm btn-danger"
                                                                onClick={() =>
                                                                  handleOpenDeleteModal(
                                                                    packageItem.packageId
                                                                  )
                                                                }
                                                              >
                                                                <i className="ri-delete-bin-line align-bottom me-1"></i>{" "}
                                                                Delete
                                                              </button>
                                                             <button
                                className="btn btn-sm btn-info"
                                onClick={() =>
                                  handleOpenCopyModal(packageItem.packageId) // Changed from handleClone
                                }
                                disabled={
                                  copyingId === packageItem.packageId
                                }
                              >
                                <i className="ri-file-copy-line align-bottom me-1"></i>
                                {copyingId === packageItem.packageId
                                  ? "Copying..."
                                  : "Copy"}
                              </button>
                                                            </div>
                                                          </div>
                                                        </div>
                          </div>
                        </div>
                      ))}
                    </div>

                    {lists.length === 0 && (
                      <div className="text-center py-5">
                        <div className="text-muted">
                          <i className="ri-global-line display-5"></i>
                          <h5 className="mt-3">No Website Packages Found</h5>
                          <p>Go to the main 'Packages' list to mark packages for the website.</p>
                        </div>
                      </div>
                    )}

                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                                          <div className="flex-shrink-0">
                                            <div className="text-muted">
                                              Showing{" "}
                                              <span className="fw-semibold">{lists.length}</span> of{" "}
                                              <span className="fw-semibold">{totalRecords}</span>{" "}
                                              Results
                                            </div>
                                          </div>
                                          <ul className="pagination pagination-separated pagination-sm mb-0">
                                            <li
                                              className={`page-item ${pageNumber === 1 ? "disabled" : ""
                                                }`}
                                              onClick={GetFirstPageData}
                                            >
                                              <Link className="page-link">Previous</Link>
                                            </li>
                                            {renderPageNumbers}
                                            <li
                                              className={`page-item ${pageNumber === totalPages ? "disabled" : ""
                                                }`}
                                              onClick={GetLastPageData}
                                            >
                                              <Link className="page-link">Next</Link>
                                            </li>
                                          </ul>
                                        </div>
                  </>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <DeleteAlert show={showDeleteModal} handleClose={handleCloseDeleteModal} handleDelete={handleDelete}/>
      <ConfirmationModal
        show={showCopyModal}
        handleClose={handleCloseCopyModal}
        handleConfirm={handleClone}
        title="Confirm Copy"
        message="Are you sure you want to make a copy of this package?"
        confirmText="Yes, Copy"
        confirmVariant="info" // Corresponds to the blue button color
        iconClass="ri-file-copy-line"
      />
    </div>
   
  );
};

export default WebsiteUmrahList;